import { apiCall } from './api';

const covid19 = data => apiCall('POST', '/api/covid19', data);
const health_contact = (data) => apiCall('POST', '/api/covid19/contact', data);

export default {
    covid19,
    health_contact
}